const DB_NAME: string = "mockDatabase"
const STORE_NAME: string = "mockStore"

export function formatEndpoint(options): string {
  if (!options?.params) return options?.url
  const queryString = Object.keys(options.params)
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(options.params[key])}`
    )
    .join("&")
  return `${options.url}?${queryString}`
}

export function openDB(): Promise<IDBDatabase> {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request: IDBOpenDBRequest = indexedDB.open(DB_NAME, 1)

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db: IDBDatabase = (event.target as any).result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME)
      }
    }

    request.onsuccess = (event: Event) => {
      const db: IDBDatabase = (event.target as any).result
      resolve(db)
    }

    request.onerror = (event: Event) => {
      const error: DOMException = (event.target as any).error
      reject(error)
    }
  })
}

export async function setDB(endpoint: string, data: any): Promise<void> {
  const db: IDBDatabase | undefined = await openDB()
  if (db) {
    const tx: IDBTransaction = db.transaction(STORE_NAME, "readwrite")
    const store: IDBObjectStore = tx.objectStore(STORE_NAME)
    store.put(data, endpoint)
  }
}

export async function getDB(endpoint: string): Promise<any | undefined> {
  const db: IDBDatabase | undefined = await openDB()
  return new Promise<any | undefined>((resolve, reject) => {
    if (db) {
      const tx: IDBTransaction = db.transaction(STORE_NAME, "readonly")
      const store: IDBObjectStore = tx.objectStore(STORE_NAME)
      const response: IDBRequest = store.get(endpoint)

      response.onsuccess = () => {
        const result: any = response.result
        resolve(result)
      }

      response.onerror = (event: Event) => {
        const error: DOMException = (event.target as any).error
        reject(error)
      }
    } else {
      resolve(undefined)
    }
  })
}
